import { render } from "./IntegerField.vue?vue&type=template&id=cc2c7c1c&ts=true"
import script from "./IntegerField.vue?vue&type=script&lang=ts"
export * from "./IntegerField.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__